<template>
  <div class="obs_container obs_experience">
    <h2 class="obs_heading typo-h2 text-light-high text-center">{{ $t("onboardingStep.primaryGoal.title") }}</h2>
    <div class="obs_body">
      <div class="obs_body-describes col-5 mx-auto col-sm-8">
        <div class="row">
          <div class="col-12">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.primaryGoal.option1.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.primaryGoal.option1.key'))" :label="$t('onboardingStep.primaryGoal.option1.text')" :value="$t('onboardingStep.primaryGoal.option1.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.primaryGoal.option2.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.primaryGoal.option2.key'))" :label="$t('onboardingStep.primaryGoal.option2.text')" :value="$t('onboardingStep.primaryGoal.option2.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.primaryGoal.option3.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.primaryGoal.option3.key'))" :label="$t('onboardingStep.primaryGoal.option3.text')" :value="$t('onboardingStep.primaryGoal.option3.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="obs_describes-item pdl20" :class="{ active: currentSelect == $t('onboardingStep.primaryGoal.option4.key') }">
              <GpRadioButton @change="selectItem($t('onboardingStep.primaryGoal.option4.key'))" :label="$t('onboardingStep.primaryGoal.option4.text')" :value="$t('onboardingStep.primaryGoal.option4.key')" v-model="optionsValue" />
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="obs_describes-item pdl20 fl-col" :class="{ 'padding_expand active': specifySelect }">
              <GpRadioButton @change="selectItem($t('onboardingStep.primaryGoal.option5.key'))" :label="$t('onboardingStep.primaryGoal.option5.text')" :value="$t('onboardingStep.primaryGoal.option5.key')" v-model="optionsValue" />
              <TransitionExpand>
                <textarea ref="contentTextArea" :class="{ showing: specifySelect, invalid: isSpecifyBlank }" type="text" @keyup="checkBlankText" v-model="specifyValue" :placeholder="$t('onboardingStep.primaryGoal.option5Placholder')" />
              </TransitionExpand>
              <span class="obs_invalid typo-body2" v-if="isSpecifyBlank && specifySelect">{{ $t("onboardingStep.describes.invalidMessage") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="obs_footer">
      <button type="button" class="obs_btn disabled" v-if="!isFormValid" v-popover:tooltip.top="$t('onboardingStep.primaryGoal.tooltip')">{{ $t("onboardingStep.primaryGoal.button") }}</button>

      <button type="button" class="obs_btn" v-if="isFormValid" @click="submitForm">{{ $t("onboardingStep.primaryGoal.button") }}</button>
    </div>
  </div>
</template>

<script>
import { GpRadioButton } from "@/core/shared/GpForms";
import { mapMutations, mapState } from "vuex";
import { mutations } from "@/store/onboarding/types.js";
import obsLocalData from "@/utils/obsLocalData.js";
export default {
  name: "Describes",
  components: {
    GpRadioButton
  },
  props: {
    userName: String,
    step: Number
  },
  data() {
    return {
      optionsValue: [],
      dataPrimaryGoal: [],
      specifySelect: false,
      specifyValue: "",
      isSpecifyBlank: false,
      startTime: Date,
      endTime: Date,
      currentSelect: ""
    };
  },
  computed: {
    ...mapState("onboarding", {
      primaryGoal: state => state.primaryGoal
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    isFormValid() {
      return this.checkFormValid();
    }
  },
  created() {
    setTimeout(() => {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      if (obsLocalData.check(shopifyDomain)) {
        const lastSurvey = obsLocalData.get(shopifyDomain);
        if (lastSurvey && lastSurvey.store && lastSurvey.store.primaryGoal) {
          this.initData(lastSurvey.store.primaryGoal);
        }
      } else {
        this.initData(this.primaryGoal);
      }
    }, 300);
    this.startTime = new Date().getTime();
  },
  methods: {
    ...mapMutations("onboarding", {
      obsPrimarygoal: mutations.OBS_PRIMARYGOAL
    }),
    submitForm() {
      this.endTime = new Date().getTime();
      const timeCounter = this.endTime - this.startTime;
      if (this.specifySelect && !this.specifyValue) {
        this.isSpecifyBlank = true;
        return;
      } else {
        const dataPrimaryGoal = this.optionsValue;
        const dataStep = {
          optionsValue: dataPrimaryGoal,
          specifyValue: this.specifyValue,
          specifySelect: this.specifySelect,
          time: timeCounter,
          data: dataPrimaryGoal.join()
        };
        this.obsPrimarygoal(dataStep);
        const shopifyDomain = this.shopInfo.shopifyDomain;
        obsLocalData.set(dataStep, "primaryGoal", shopifyDomain);
        obsLocalData.set(this.step, "currentStep", shopifyDomain);

        this.$emit("data");
        this.nextStep();
      }
    },
    nextStep() {
      this.$emit("next", this.step);
    },
    checkBlankText() {
      if (this.specifySelect && this.specifyValue) {
        this.isSpecifyBlank = false;
      } else {
        this.isSpecifyBlank = true;
      }
    },
    checkFormValid() {
      let result = false;
      const specifyCheck = this.specifySelect && this.specifyValue;
      const optionCheck = this.optionsValue.length;
      if (specifyCheck || optionCheck) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    initData(primaryGoal) {
      this.optionsValue = primaryGoal.optionsValue;
      this.specifyValue = primaryGoal.specifyValue;
      this.specifySelect = primaryGoal.specifySelect;
    },
    selectItem(value) {
      this.currentSelect = value;
      if (value === this.$t("onboardingStep.primaryGoal.option5.key")) {
        this.specifySelect = true;
        setTimeout(() => {
          const textarea = this.$refs.contentTextArea;
          textarea.focus();
        }, 200);
      } else {
        this.specifyValue = "";
        this.specifySelect = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.obs_experience {
  width: 100%;
  height: 100%;
}
</style>
